import styled from 'styled-components';
import CurvedLine from '../assets/svg/CurvedLine1';
import Flower from '../assets/svg/Flower';
import HeroTooltip from '../assets/svg/HeroTooltip';
import HeroTooltipMobile from '../assets/svg/HeroTooltipMobile';
import ButtonArrowIcon from '../../../assets/svg/ButtonArrowIcon';
import { Link } from 'react-router-dom';
import { PUBLIC_IMAGES_REPO } from '../../../../../utils/Constants';

const HeroImage = `${PUBLIC_IMAGES_REPO}/HeroThemeSettings.webp`;

const HeroWrapper = styled.section`
background-color: #D443A0;
position: relative;

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1440px;
}

:after{
  content:"";
  position:absolute;
  right:0;
  bottom: -1px;
  width: 100%;
  height: 15%;
  z-index: 0;
  background: var(--BG-Color, #F2F2F2);
}

.curved-line {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.flower-small {
  position: absolute;
  top: 25%;
  left: 0%;

  svg{
    width: 45%;
  }
}

.flower-big {
  position: absolute;
  top: 40%;
  left: -1%;

  svg{
    width: 95%;
  }
}

.banner-info{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  margin-top: 200px;
  margin-bottom: 150px;
  width: 80%;

  .rect-container{
    position: relative;
    border: 5px solid;
    margin: 0px 10px;
    padding: 0px 10px;
    background-color: #CB1D8D;
    
    .rect-1 {
      position: absolute;
      top: -15px;
      left: -15px;
      height: 30px;
      width: 30px;
      border: 5px solid;
      background-color: #CB1D8D;
    }

    .rect-2 {
      position: absolute;
      top: -15px;
      right: -15px;
      height: 30px;
      width: 30px;
      border: 5px solid;
      background-color: #CB1D8D;
    }

    .rect-3 {
      position: absolute;
      bottom: -15px;
      left: -15px;
      height: 30px;
      width: 30px;
      border: 5px solid;
      background-color: #CB1D8D;
    }

    .rect-4 {
      position: absolute;
      bottom: -15px;
      right: -15px;
      height: 30px;
      width: 30px;
      border: 5px solid;
      background-color: #CB1D8D;
    }
  }

  h1{
    color: var(--gray-gray-50, #F9F9F9);
    font-family: Instrument Sans;
    font-size: 88px;
    font-style: normal;
    font-weight: 700;
    line-height: 104px;
    z-index: 1;
  }    

    p{
      color: var(--white-shades-white-100, #FFF);
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px;
      margin-top: 24px;
      width: 70%
    }
    
  }
      
  .action-button{
    border-radius: 8px;
    border: 2px solid var(--gray-gray-200, #EDEDED);
    background: var(--gray-gray-200, #EDEDED);
    margin-top: 48px;
    padding: 19px 36px;
  
    color: var(--font-color-font-1, #1B131F);
  
    font-family: Instrument Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
  }

  .tooltip-tag{
    display: block;
    position: absolute;
    bottom: -36%;
    left: 17%;

    svg{
      width: 120%
    }
  }

  .tooltip-tag-mobile{
    display: none;
  }
}

.hero-image{
  width: 70%;
  z-index: 1;
  min-height: 690px;
  object-fit: contain;
}

@media screen and (max-width: 1024px){
  .banner-info{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    text-align: center;
    margin-top: 200px;
    margin-bottom: 150px;
    width: 65%;
  
    h1{
      font-size: 62px;
      line-height: 88px;
    }    
  
      p{
        font-size: 22px;
        line-height: 36px;
      }
    }
        
    .action-button{
      padding: 16px 32px;
    }
  
    .tooltip-tag{
      display: block;
      position: absolute;
      bottom: -35%;
      left: 10%;
  
      svg{
        width: 110%
      }
    }
  }
  
  .hero-image{
    width: 80%;
    height: 100%;
    min-height: 490px;
  }
}

@media screen and (max-width: 768px) {

  .flower-small {
    position: absolute;
    top: 18%;
    left: 0%;
  
    svg{
      width: 10%;
    }
  }
  
  .flower-big {
    position: absolute;
    top: 32%;
    left: -1%;
  
    svg{
      width: 18%;
    }
  }

  .banner-info{
    margin: 0;
    padding: 40px 20px;
    width: 100%;
  
    .rect-container{
      position: relative;
      border: 2px solid;
      margin: 0px 5px;
      padding: 0px 5px;
      background-color: #CB1D8D;
      
      .rect-1 {
        position: absolute;
        top: -5px;
        left: -5px;
        height: 10px;
        width: 10px;
        border: 2px solid;
        background-color: #CB1D8D;
      }
  
      .rect-2 {
        position: absolute;
        top: -5px;
        right: -5px;
        height: 10px;
        width: 10px;
        border: 2px solid;
        background-color: #CB1D8D;
      }
  
      .rect-3 {
        position: absolute;
        bottom: -5px;
        left: -5px;
        height: 10px;
        width: 10px;
        border: 2px solid;
        background-color: #CB1D8D;
      }
  
      .rect-4 {
        position: absolute;
        bottom: -5px;
        right: -5px;
        height: 10px;
        width: 10px;
        border: 2px solid;
        background-color: #CB1D8D;
      }
    }

    h1{
      font-size: 32px;
      line-height: 40px;
      z-index: 1;
    }
  
  
    p{
      font-size: 16px;
      line-height: 24px;
      margin-top: 8px;
      width: 100%
    }
      
    .action-button{
      margin-top: 24px;
      padding: 12px 16px;
    
      font-size: 16px;
      line-height: 20px;
    }
  
    .tooltip-tag{
      display: none;
      bottom: -40%;
      left: -6%;
  
      svg{
        width: 75%
      }
    }

    .tooltip-tag-mobile{
      display: block;
      position: absolute;
      bottom: -25%;
      left: 4%;
  
      svg{
        width: 100%
      }
    }
  }

  .hero-image{
    margin-top: 80px;
    width: 100%;
    z-index: 1;
    min-height: 180px;
  }
}
`;

const StyledH5 = styled.h5`
  color: var(--white-shades-white-100, #fff);
  font-family: 'Instrument Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  margin-top: 24px;
  width: 70%;
`;
const Hero = () => {
  return (
    <HeroWrapper>
      <div className="container">
        <div className="curved-line">
          <CurvedLine />
        </div>
        <div className="flower-small">
          <Flower />
        </div>
        <div className="flower-big">
          <Flower />
        </div>

        <div className="banner-info">
          <h1>
            Build a Florist{' '}
            <span className="rect-container">
              website
              <span className="rect-1" />
              <span className="rect-2" />
              <span className="rect-3" />
              <span className="rect-4" />
            </span>{' '}
            for free!
          </h1>
          <StyledH5>
            Easy to Build and Manage a Floral Website
            <br />
            Created for non-technical users
          </StyledH5>
          <Link
            className="text-decoration-none"
            to="/signup"
            style={{ zIndex: '9' }}
          >
            <button className="action-button">
              Get Started <ButtonArrowIcon />
            </button>
          </Link>
          <span className="tooltip-tag">
            <HeroTooltip />
          </span>
          <span className="tooltip-tag-mobile">
            <HeroTooltipMobile />
          </span>
        </div>

        <img
          loading="lazy"
          className="hero-image"
          src={HeroImage}
          sizes="50vw"
          srcset={`${HeroImage.replace(
            '.webp',
            '_500px.webp',
          )} 500w, ${HeroImage.replace(
            '.webp',
            '_1000px.webp',
          )} 1000w, ${HeroImage.replace('.webp', '_1000px.webp')} 1500w`}
          alt="Build a custom floral website with BoostFloral using its best floral website templates and Floral website design"
        />
      </div>
    </HeroWrapper>
  );
};

export default Hero;
